<template>
	<v-col class="history-transfer">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Histori Transfer</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-database</v-icon>
			<div class="pl-2">Komisi</div>
			<div class="px-2">/</div>
			<div>Histori Transfer</div>
		</div>
		<div class="mt-5">
			<v-row justify="center">
				<v-col cols="12" sm="5" md="4">
					<v-card class="px-3 py-5 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
								<img class="img-fluid" src="/assets/icon/transfer-bonus-terakhir.png">
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-14 cl-secondary font-weight-500">
									<div>{{ bonusLastComission | toRupiah }}</div>
								</div>
								<div class="font-size-10 cl-grey">Transfer Komisi Terakhir</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col cols="12" sm="5" md="4" class="pt-0 pt-sm-3">
					<v-card class="px-3 py-5 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
								<img class="img-fluid" src="/assets/icon/summary-total-bonus.png">
							</v-col>
							<v-col cols="10" sm="9" md="9">
								<div class="font-size-14 cl-secondary font-weight-500">{{ bonusTotalComission | toRupiah }} </div>
								<div class="font-size-10 cl-grey">Total Komisi Yang Telah Ditransfer</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			<v-row justify="end">
				<v-col cols="12" sm="11" md="8" class="py-0 py-sm-3">
					<v-row justify="end" align="center">
						<v-col cols="12" sm="12" md="6"><label class="d-block text-right pr-2">Tampilkan berdasarkan</label></v-col>
						<v-col cols="12" sm="12" md="6">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field placeholder="Pilih rentang tanggal transfer" outlined dense append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" background-color="white" class="rounded-lg date-no-border" hide-details v-model="dateRangeText"></v-text-field>
								</template>
								<v-date-picker range locale="id" type="date" color="primary" @change="getData" v-model="dateStart"></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="!loading">
				<v-row v-if="listHistoryTransfer.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-history-transfer">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-center">Aksi</th>
										<th class="text-left" width="180px">Periode</th>
										<th class="text-left" width="180px">Tanggal Transfer</th>
										<th class="text-right">Jumlah</th>
										<th class="text-center">Status</th>
										<th class="text-left">Keterangan</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="history in listHistoryTransfer" :key="history.bonus_transfer_id">
										<td class="text-center">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn depressed fab x-small color="blue" v-bind="attrs" v-on="on" @click="printBonus(history.bonus_transfer_id)">
														<v-icon small color="white">mdi-printer</v-icon>
													</v-btn>
												</template>
												<span>Print</span>
											</v-tooltip>
										</td>
										<td class="text-left">{{ history.bonus_transfer_datetime | tanggal }}</td>
										<td class="text-left">
											<template v-if="history.bonus_transfer_status_update_datetime">{{ history.bonus_transfer_status_update_datetime | tanggal }}</template>
											<template v-else>-</template>
										</td>
										<td class="text-right cl-secondary font-weight-500">{{ history.bonus_transfer_nett | toRupiah }}</td>
										<td class="text-center font-weight-500">
											<v-chip
												small
												:color="getTransferStatus(history.bonus_transfer_status).color"
												class="font-weight-bold white--text text-uppercase"
												>{{ getTransferStatus(history.bonus_transfer_status).label }}</v-chip>
										</td>
										<td class="text-left">{{ history.bonus_transfer_note ? history.bonus_transfer_note : '-' }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listHistoryTransfer.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data histori transfer yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listHistoryTransfer.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historyTransferPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ historyTransferPagination.total_display }} data dari total {{ historyTransferPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			startDate: false,
			dateStart: [],  //moment().format("YYYY-MM")
			start: '',
			end: '',
			monthYear: null, //new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
			dayStart: '1',
			dayEnd: '31',
			bonusLastComission: 0,
			bonusTotalComission: 0,
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '20', '50', '100' ],
			transferStatus: [
				{
					status: 'success',
					color: 'success',
					label: 'Sukses',
					icon: 'mdi-check-decagram-outline'
				},
				{
					status: 'pending',
					color: 'warning',
					label: 'Pending',
					icon: 'mdi-timer-sand'
				},
				{
					status: 'failed',
					color: 'error',
					label: 'Gagal',
					icon: 'mdi-close-circle-outline'
				}
			]
		}
	},
	computed: {
		...mapState('bonus', ['listHistoryTransfer', 'historyTransferPagination']),
		dateRangeText() {
			if(this.dateStart.length > 0) {
				const date1 = moment(this.dateStart[0]).format("DD MMMM YYYY")
				const date2 = moment(this.dateStart[1]).format("DD MMMM YYYY")
				return date1 + '  s/d  ' + date2
			} 
			else return ''
		},
	},
	methods: {
		...mapActions('bonus', ['getHistoryTransfer']),

		getTransferStatus(status) {
			const transfer = this.transferStatus.find(x => x.status === status)
			if (transfer) return transfer
			else {
				const nontransfer = {
					status: '',
					color: 'secondary',
					label: '',
					icon: ''
				}
				return nontransfer
			}
		},

		printBonus(id) {
			let routeData = this.$router.resolve({name: 'bonus-statement', params : { slug: id} })
			window.open(routeData.href, '_blank');
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getData() {
			this.loading = true
			let start = ''
			let ends = ''

			if (this.dateStart.length > 0) {
				start = moment(this.dateStart[0]).format("YYYY-MM-DD")
				ends = moment(this.dateStart[1]).format("YYYY-MM-DD")
			}

			let params = {
				limit: this.limit, 
				page: this.page, 
				sort: 'history.bonus_transfer_datetime', 
				dir: 'DESC',
				start: start,
				end: ends
			}

			this.startDate = false
			this.getHistoryTransfer(params).then((response) => {
				this.bonusLastComission = response.bonus_last_comission
				this.bonusTotalComission = response.bonus_total_comission
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Histori Transfer`)
		this.getData()
	}
};
</script>

